import { useMissionsTranslation } from '../../../../../../../../ui/hooks';
import { Grid } from '@mui/material';
import React from 'react';
import { ParticipationsStatusCard } from './ParticipationsStatusCard';
export const ParticipationsStatus = ({ denied, oigFailed, multiplePositions }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { size: {
                xs: 12,
                sm: 4,
            } },
            React.createElement(ParticipationsStatusCard, { value: denied, label: t('shifts.pendingRequest.review.banner.denied') })),
        React.createElement(Grid, { size: {
                xs: 12,
                sm: 4,
            } },
            React.createElement(ParticipationsStatusCard, { value: oigFailed, label: t('shifts.pendingRequest.review.banner.oigFailed') })),
        React.createElement(Grid, { size: {
                xs: 12,
                sm: 4,
            } },
            React.createElement(ParticipationsStatusCard, { value: multiplePositions, label: t('shifts.pendingRequest.review.banner.multiplePositions') }))));
};
